import { Fragment } from "react";
import { Award, Clock, ShieldCheck, Star } from "lucide-react";

// @ts-ignore //Weird image issues...
import HeroImage from "../assets/SparkyHero1.png";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";

const stats = [
  { icon: Award, label: "Family-Trained Expertise" },
  { icon: ShieldCheck, label: "Fully Licensed & Insured" },
  { icon: Clock, label: "24/7 Emergency Call-Outs" },
  { icon: Star, label: "80+ Five-Star Reviews" },
];

export const Hero1 = () => {
  return (
    <section id="home" className="relative w-full overflow-hidden bg-neutral-900">
      <img
        src={HeroImage}
        alt="E.I.M Electrical Contractors electrician at work"
        className="absolute inset-0 h-full w-full object-cover object-[50%_50%]"
      />
      <div className="absolute inset-0 bg-linear-to-r from-black/85 from-10% via-black/55 to-black/30" />
      <div className="relative mx-auto flex min-h-140 max-w-360 flex-col justify-center gap-10 px-4 py-24 md:px-8">
        <div className="flex max-w-2xl flex-col gap-4">
          <span className="w-fit rounded-full bg-primary/20 px-3 py-1 text-sm font-semibold text-primary ring-1 ring-primary/50">
            Blackpool's Trusted Local Sparky
          </span>
          <h1 className="text-4xl font-bold text-white sm:text-5xl">
            Residential & Commercial Electrical Services Across the Fylde Coast
          </h1>
          <p className="text-lg font-light text-neutral-300">
            Professional electrical work across the Fylde Coast. Upfront pricing,
            no hidden costs, and 78 five-star Google reviews.
          </p>
          <div className="flex flex-wrap gap-3 pt-2">
            <Button size="lg" asChild>
              <a href="#quote">Get a Free Quote</a>
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-white/30 bg-transparent text-white hover:bg-white/10 hover:text-white"
              asChild
            >
              <a href="tel:07850458907">Call 07850 458907</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
